import { ActionButton, } from '@fluentui/react';
import { IconNames } from '@office-start/fabric-icon-subset-utility';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import styles from './UploadButtonControl.module.scss';
var UploadButtonControlRender = function (_a, forwardRef) {
    var uploadActionTitle = _a.uploadActionTitle, isDisabled = _a.isDisabled, isNewFluentStyle = _a.isNewFluentStyle, buttonId = _a.buttonId, onButtonClick = _a.onButtonClick;
    var uploadButtonStyle = useMemo(function () { return ({
        textContainer: styles['upload-button__text'],
    }); }, []);
    var uploadButtonIconStyle = useMemo(function () { return ({
        root: styles['upload-button__icon'],
    }); }, []);
    var uploadButtonNewFluentStyle = useMemo(function () { return ({
        icon: styles['upload-button__icon__fluent'],
    }); }, []);
    var uploadIcon = useMemo(function () { return ({
        iconName: IconNames.Upload,
        styles: !isNewFluentStyle ? uploadButtonIconStyle : undefined,
    }); }, [uploadButtonIconStyle, isNewFluentStyle]);
    return (React.createElement(ActionButton, { className: classNames(isNewFluentStyle
            ? styles['upload-button__newFluentStyle']
            : styles['upload-button']), elementRef: forwardRef, iconProps: uploadIcon, styles: !isNewFluentStyle
            ? uploadButtonStyle
            : uploadButtonNewFluentStyle, text: uploadActionTitle, onClick: onButtonClick, id: buttonId, "data-clicklog": "custom", disabled: !!isDisabled }));
};
UploadButtonControlRender.displayName = 'UploadButtonControl';
export var UploadButtonControl = React.forwardRef(UploadButtonControlRender);
//# sourceMappingURL=UploadButtonControl.js.map